// extracted by mini-css-extract-plugin
export default {"portfolioErrorContainer":"styles_portfolioErrorContainer__+v6ek","spinnerWrapper":"styles_spinnerWrapper__+zo3b","errorIcon":"styles_errorIcon__D36Ty"};